import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";

import { SHOP } from "../config";
import logoMark from "../img/logo.svg";

// The Gatsby site built the mobile menu by hand in static/scripts/hamburger.js.
// Here it is just a piece of state.
const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // The "Sortiment" dropdown is opened/closed in JS rather than by :hover, with
  // a short close delay. A pure-CSS hover menu flickered and sometimes stuck
  // open when the cursor crossed the small gap to the panel.
  const [sortOpen, setSortOpen] = useState(false);
  const closeTimer = useRef(null);

  // The navbar is re-mounted on every route change (each page has its own
  // Layout). When the new navbar appears under a stationary cursor, the browser
  // fires a synthetic mouseenter on the "Sortiment" item, which would re-open
  // the menu right after navigating. Ignore open requests for a moment after
  // mount so that only a real hover/focus opens it.
  const mountedAt = useRef(Date.now());

  const openSort = () => {
    if (Date.now() - mountedAt.current < 400) return;
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setSortOpen(true);
  };

  const scheduleCloseSort = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setSortOpen(false), 140);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setSortOpen(false);
  };

  return (
    <>
      <header>
        <div className="topandbottom">
          <p className="topandbottom-text">
            <i className="fa fa-map-marker" />
            {SHOP.address}
          </p>
          <div className="contact">
            <a href={`mailto:${SHOP.email}`}>
              <i className="fa fa-envelope" />
              {SHOP.email}
            </a>
            <a href={`tel:${SHOP.phone}`}>
              <i className="fa fa-phone" />
              {SHOP.phoneDisplay}
            </a>
          </div>
        </div>
      </header>
      <div className="logo-and-nav-container">
        <div className="logo-and-nav">
          <span className="logo">
            <Link to="/" onClick={closeMenu}>
              <img className="logo-mark" src={logoMark} alt="" aria-hidden="true" />
              Optika Volyně
            </Link>
          </span>
          <nav>
            <ul>
              <li>
                <Link to="/galerie">Galerie</Link>
              </li>
              <li>
                <Link to="/novinky">Novinky</Link>
              </li>
              <li
                className={`dropdown-line${sortOpen ? " is-open" : ""}`}
                onMouseEnter={openSort}
                onMouseLeave={scheduleCloseSort}
                onFocus={openSort}
                onBlur={scheduleCloseSort}
              >
                <Link to="/sluzby" onClick={() => setSortOpen(false)}>
                  Sortiment
                </Link>
                <div className="dropdown-pages">
                  <Link to="/sluzby/optometrie" onClick={() => setSortOpen(false)}>
                    Optometrie
                  </Link>
                  <Link to="/sluzby/bryle" onClick={() => setSortOpen(false)}>
                    Brýle
                  </Link>
                  <Link to="/sluzby/cocky" onClick={() => setSortOpen(false)}>
                    Kontaktní čočky
                  </Link>
                  <Link to="/sluzby/doplnky" onClick={() => setSortOpen(false)}>
                    Doplňky
                  </Link>
                </div>
              </li>
              <li>
                <Link to="/reference">Reference</Link>
              </li>
              <li>
                <Link to="/kontakt">Kontakt</Link>
              </li>
            </ul>
            <a
              className="nav-cta"
              href={SHOP.reservio}
              target="_blank"
              rel="noreferrer"
            >
              <i className="fa fa-calendar-check-o" />
              Objednat se
            </a>
            <button
              type="button"
              className={`hamburger${menuOpen ? " change" : ""}`}
              aria-label="Menu"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((open) => !open)}
            >
              <div className="bar1" />
              <div className="bar2" />
              <div className="bar3" />
            </button>
          </nav>
        </div>
        {menuOpen && (
          <div className="ham-nav">
            <div>
              <Link to="/galerie" onClick={closeMenu}>
                Galerie
              </Link>
              <Link to="/novinky" onClick={closeMenu}>
                Novinky
              </Link>
              <Link to="/sluzby" onClick={closeMenu}>
                Sortiment
              </Link>
              <Link to="/reference" onClick={closeMenu}>
                Reference
              </Link>
              <Link to="/kontakt" onClick={closeMenu}>
                Kontakt
              </Link>
              <a
                className="nav-cta"
                href={SHOP.reservio}
                target="_blank"
                rel="noreferrer"
                onClick={closeMenu}
              >
                <i className="fa fa-calendar-check-o" />
                Objednat se online
              </a>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Navbar;
